/* eslint-disable */
import { CHECKER_NORMAL_24 } from "@sznds/icons";
import { node } from "~/util/dom";
import createSDSIcon from "./icon";
import { getIcon } from "~/util/providers/poiagg";

interface IPOISelectItemOptions {
	typeId: number;
	title: string;
	subtitle: string;
	selected?: boolean;
}

export default class POISelectItem {
	_container: HTMLLIElement;
	_selected: boolean;

	constructor({
		typeId,
		title,
		subtitle,
		selected = false,
	}: IPOISelectItemOptions) {
		this._container = node("li", { className: "ui-poiSelectItem" });
		this.selected = selected;

		// ikona
		const iconUrl: string = getIcon(typeId);

		if (iconUrl) {
			this._container.appendChild(node("img", { className: "ui-poiSelectItem__icon", src: iconUrl, crossOrigin: "anonymous" }));
		} else {
			this._container.appendChild(node("span", { className: "ui-poiSelectItem__icon" }));
		}

		// texty
		const text = node("div", { className: "ui-poiSelectItem__text" });

		text.appendChild(node("h3", { innerHTML: title }));
		text.appendChild(node("p", { innerHTML: subtitle }));
		this._container.appendChild(text);

		// zaskrtavatko
		const check = createSDSIcon({
			symbol: CHECKER_NORMAL_24,
		});

		this._container.appendChild(check);
	}

	get node() {
		return this._container;
	}

	set selected(selected: boolean) {
		this._container.classList[selected ? "add" : "remove"]("ui-poiSelectItem--selected");
		this._selected = selected;
	}
}
